import { getLinePath, getArrowHeadPoints, type LineType } from '../lib/lineMath';

interface ArrowOverlayProps {
  /** Array of [x, y] coordinate pairs (in the same unit space as viewBox) */
  coords: [number, number][];
  type: LineType;
  /** Width of the coordinate space (for viewBox) */
  viewBoxWidth: number;
  /** Height of the coordinate space (for viewBox) */
  viewBoxHeight: number;
  /** Whether this overlay is currently visible */
  visible?: boolean;
  strokeColor?: string;
  strokeWidth?: number;
}

/**
 * SVG arrow/line overlay rendered on top of media.
 * Uses a viewBox matching the original coordinate space so the drawing
 * scales correctly when the container is resized.
 */
export function ArrowOverlay({
  coords,
  type,
  viewBoxWidth,
  viewBoxHeight,
  visible = true,
  strokeColor = '#e32d4b',
  strokeWidth = 4,
}: ArrowOverlayProps) {
  if (!visible || !coords.length || !viewBoxWidth || !viewBoxHeight) return null;

  const pathD = getLinePath(coords, type);
  const arrowPoints = getArrowHeadPoints(coords, type);

  return (
    <svg
      className="pointer-events-none absolute inset-0 z-[2] size-full"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      preserveAspectRatio="none"
    >
      <path
        d={pathD}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
      {arrowPoints && (
        <polygon
          points={arrowPoints}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          fill={strokeColor}
        />
      )}
    </svg>
  );
}
